import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRouterModule } from './app.router.module';
import { AuthModule } from "./auth/auth.module";
import { SharedModule } from '../shared/shared.module';
import { RouterOutlet } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// B2C Auth setup:
// Import the Angular HTTP interceptor. 
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ClaimModule } from './claims/claim.module';
import { ReimbursementModule } from './reimbursement/reimbursement.module';

// Import MSAL and MSAL browser libraries. 
import { MsalGuard, MsalInterceptor, MsalModule, MsalRedirectComponent } from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';

// Import the Azure AD B2C configuration
import { msalConfig, protectedResources } from './auth-config';

// Add the essential Angular materials.
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { NgIf } from "@angular/common";

// App modules
import { ClaimsAppModule } from "./claims-app/claims-app.module";

@NgModule({
    declarations: [
        AppComponent,
    ],
    bootstrap: [AppComponent, MsalRedirectComponent],
    imports:
        [
            BrowserAnimationsModule,
            NgbModule,
            ReactiveFormsModule,
            RouterOutlet,
            SharedModule,
            ClaimsAppModule,
            ClaimModule,
            ReimbursementModule,
            AuthModule,
            // Import the following Angular materials. 
            MatButtonModule,
            MatToolbarModule,
            MatListModule,
            MatTableModule,
            
            // Initiate the MSAL library with the MSAL configuration object
            MsalModule.forRoot(new PublicClientApplication(msalConfig),
                {
                    // The routing guard configuration. 
                    interactionType: InteractionType.Redirect,
                    authRequest: {
                        scopes: protectedResources.scopes
                    }
                },
                {
                    // MSAL interceptor configuration.
                    // The protected resource mapping maps your web API with the corresponding app scopes. If your code needs to call another web API, add the URI mapping here.
                    interactionType: InteractionType.Redirect,
                    protectedResourceMap: new Map([
                        [protectedResources.userApi.endpoint, protectedResources.userApi.scopes],
                        [protectedResources.claimApi.endpoint, protectedResources.claimApi.scopes],
                        [protectedResources.referenceApi.endpoint, protectedResources.referenceApi.scopes],
                    ])
                }
            ),
            NgIf,
            AppRouterModule
        ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        },
        MsalGuard,
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AppModule {
}
